import { BaseColumnsDropzone } from 'components/ui/index';
import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import { DropTarget } from 'react-dnd';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import { compose } from 'redux';
import Enums from 'utils/EnumsManager';
import { moveToZone } from 'views/ReportTableSetup/flow/actions';
import Tag from './Tag';

const { FieldTypesInArray, DROPZONES } = Enums;

const propTypes = {
  isOver: PropTypes.bool.isRequired,
  filteredData: PropTypes.array.isRequired
};

class DropZone extends PureComponent {
  render() {
    const { isOver, connectDropTarget, filteredData } = this.props;

    return connectDropTarget(
      <div>
        <BaseColumnsDropzone
          isOver={isOver}
          description={
            <FormattedMessage id="page.ReportSetup.leftSider.noData" />
          }
        >
          {filteredData.map(record => (
            <Tag
              key={record.id}
              {...record}
              // WARNING: Because record is an instance, all properties of the instance is accessed by getter, we have to explicit pass all necessary props on the component.
              //          Otherwise will cause issue when DnD internal access on some props.
              id={record.id}
              name={record.name}
              type={record.type}
              label={record.label}
              disabled={record.disabled}
              belongTo={record.belongTo}
              fieldRestricted={record.fieldRestricted}
            />
          ))}
        </BaseColumnsDropzone>
      </div>
    );
  }
}

const spec = {
  drop: (props, monitor) =>
    props.moveToZone(DROPZONES.SIDER, monitor.getItem().id)
};
const collect = (connector, monitor) => ({
  connectDropTarget: connector.dropTarget(),
  isOver: monitor.isOver()
});
const mapStateToProps = ({ global, reportSetup }) => ({
  lang: global.language,
  data: reportSetup.sider.availableColumns
});
const mapDispatchToProps = {
  moveToZone
};

const enhancers = compose(
  connect(
    mapStateToProps,
    mapDispatchToProps
  ),
  DropTarget(FieldTypesInArray, spec, collect)
);

DropZone.propTypes = propTypes;
export default enhancers(DropZone);



// WEBPACK FOOTER //
// ./src/views/ReportSetup/components/LeftSider/components/DropZone.jsx